<template>
    <div class="dashboard-page">
        <FocusedDashboardShell :goal-id="goalId" :is-dark="theme === THEMES.DARK" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import FocusedDashboardShell from "../../components/analytics/FocusedDashboardShell.vue"
import { getAnalyticsDashboardById } from "../../utils/analytics-dashboard-goals"

export default {
    name: "FocusedDashboardPage",
    components: {
        FocusedDashboardShell,
    },
    props: {
        goalId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
        dashboard() {
            return getAnalyticsDashboardById(this.goalId)
        },
    },
    mounted() {
        this.setPageTitle()
    },
    watch: {
        goalId() {
            this.setPageTitle()
        },
    },
    methods: {
        ...mapActions("misc", ["setData"]),
        setPageTitle() {
            this.setData({
                pageTitle: this.dashboard ? this.dashboard.title : "Dashboard",
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@use "@/assets/variables.scss" as *;

.dashboard-page {
    padding: $cardPaddingY;
}
</style>
